/**
 * 自动交易 API 封装
 */
import apiClient from './client';
import type { AutoTradeStatus, AutoTradeResult, DailyPnl } from '../types';

/** 获取自动交易状态 */
export async function fetchAutoTradeStatus(): Promise<AutoTradeStatus> {
  const res = await apiClient.get('/auto-trade/status');
  return res.data;
}

/** 开启/关闭自动交易 */
export async function toggleAutoTrade(enabled: boolean): Promise<AutoTradeStatus> {
  const res = await apiClient.post('/auto-trade/toggle', { enabled });
  return res.data;
}

/** 手动触发完整自动交易周期 */
export async function runAutoTrade(): Promise<AutoTradeResult> {
  const res = await apiClient.post('/auto-trade/run');
  return res.data;
}

/** 手动触发卖出条件检查 */
export async function sellCheckAutoTrade(): Promise<{ sold: number; trades: any[] }> {
  const res = await apiClient.post('/auto-trade/sell-check');
  return res.data;
}

/** 获取每日盈亏历史 */
export async function fetchDailyPnl(limit: number = 30): Promise<DailyPnl[]> {
  const res = await apiClient.get('/auto-trade/daily-pnl', { params: { limit } });
  return res.data;
}

/** 更新自动交易配置 */
export async function updateAutoTradeConfig(config: { maxStocks?: number; buyAmountPerStock?: number; buyTime?: string }): Promise<AutoTradeStatus> {
  const res = await apiClient.put('/auto-trade/config', config);
  return res.data;
}

/** 手动记录今日盈亏 */
export async function recordDailyPnl(): Promise<void> {
  await apiClient.post('/auto-trade/record-pnl');
}
